// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useLayoutEffect } from 'react';
import 'scorm-again';
import ScormContainer from 'react-scorm-container';
export type ScormViewerProps = {
  learner_id?: string | number;
  learner_name?: string;
  suspend_data?: string;
  scorm_path: string;
  session_time?: string;
  progress_measure?: string;
  onCommit?: (data: {
    suspend_data: string;
    session_time: string;
    progress_measure: string;
    detailed_analytics: string;
    score: string;
  }) => void;
};
export function ScormViewer({
  learner_id,
  learner_name,
  suspend_data,
  scorm_path,
  session_time,
  progress_measure,
  onCommit,
}: Readonly<ScormViewerProps>) {
  useLayoutEffect(() => {
    const settings = {
      autocommitSeconds: 10,
      autocommit: true,
      sendFullCommit: true,
      logLevel: 4,
      alwaysSendTotalTime: true,
    };

    window.API_1484_11 = new Scorm2004API(settings);
    const json = {
      'cmi.learner_id': learner_id,
      'cmi.learner_name': learner_name,
      'cmi.suspend_data': suspend_data,
      'cmi._session_time': session_time,
      'cmi.progress_measure': progress_measure,
      // 'cmi.score._raw': 100,
      // 'cmi.completion_status': 'completed',
      // 'cmi.interactions.0.id': 'Question14_1',
      // 'cmi.interactions.0.type': 'choice',
      // 'cmi.interactions.0.timestamp': '2018-08-26T11:05:21',
      // 'cmi.interactions.0.weighting': '1',
      // 'cmi.interactions.0.learner_response': 'HTH',
      // 'cmi.interactions.0.result': 'wrong',
      // 'cmi.interactions.0.latency': 'PT2M30S',
      // 'cmi.interactions.0.objectives.0.id': 'Question14_1',
      // 'cmi.interactions.0.objectives.0.correct_responses.0.pattern': 'CPR',
    };

    window.API_1484_11.loadFromFlattenedJSON(json);
    window.API_1484_11.on('Commit', function (CMIElement, value) {
      try {
        const suspend_data = window.API_1484_11.cmi.suspend_data;
        const progress_measure = window.API_1484_11.cmi.progress_measure;
        const score = window.API_1484_11.cmi?.score?._raw;
        const total_time = window.API_1484_11.GetValue('cmi.total_time');

        const detailedAnalytics = {
          interactions: extractAllInteractions(window.API_1484_11.cmi),
          objectives: extractAllObjectives(window.API_1484_11.cmi),
          location: window.API_1484_11.cmi.location,
          completion_status: window.API_1484_11.cmi.completion_status,
          success_status: window.API_1484_11.cmi.success_status,
        };

        if (onCommit && typeof onCommit === 'function') {
          onCommit({
            suspend_data,
            detailed_analytics: JSON.stringify(detailedAnalytics),
            session_time: total_time,
            progress_measure,
            score,
          });
        }
      } catch (error) {
        console.error('Error in commit handler:', error);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <ScormContainer width="100%" height="100%" manifestUrl={scorm_path} />;
}

function extractAllInteractions(cmi) {
  const interactions = [];
  const api = window.API_1484_11;
  const count = parseInt(api.GetValue('cmi.interactions._count')) || 0;

  for (let i = 0; i < count; i++) {
    interactions.push({
      id: api.GetValue(`cmi.interactions.${i}.id`),
      type: api.GetValue(`cmi.interactions.${i}.type`),
      learner_response: api.GetValue(`cmi.interactions.${i}.learner_response`),
      result: api.GetValue(`cmi.interactions.${i}.result`),
      description: api.GetValue(`cmi.interactions.${i}.description`),
      timestamp: api.GetValue(`cmi.interactions.${i}.timestamp`),
      latency: api.GetValue(`cmi.interactions.${i}.latency`),
      weighting: api.GetValue(`cmi.interactions.${i}.weighting`),
    });
  }
  return interactions;
}

function extractAllObjectives(cmi) {
  const objectives = [];
  const count = cmi.objectives?._count || 0;

  for (let i = 0; i < count; i++) {
    objectives.push({
      id: cmi.objectives[i]?.id,
      score: {
        raw: cmi.objectives[i]?.score?.raw,
        scaled: cmi.objectives[i]?.score?.scaled,
        min: cmi.objectives[i]?.score?.min,
        max: cmi.objectives[i]?.score?.max,
      },
      success_status: cmi.objectives[i]?.success_status,
      completion_status: cmi.objectives[i]?.completion_status,
    });
  }
  return objectives;
}
